import { FC } from 'react';
import Auth from '@aws-amplify/auth';
import storage from 'storage';

import { withApolloClient, IWithApolloClient } from 'providers';

const Logout: FC<IWithApolloClient> = ({ apolloClient }) => {
  storage.removeAll();
  window.Intercom?.('shutdown');

  async function signOut() {
    await Auth.signOut();
    await apolloClient.clearStore();
  }

  signOut();

  return null;
};

export default withApolloClient(Logout);
